import DefaultLayout from '@/components/layouts/DefaultLayout';
import StaffForm from '@/components/staff/StaffForm';
import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';

export default function StaffAdd() {
  const navigate = useNavigate();

  return (
    <DefaultLayout header="Add Staff Member">
      <StaffForm
        onSuccess={(uuid: string) => navigate(`${ROUTES.STAFF}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
